<template>
  <div>
      <div class="day-box" v-for="day in upcomingDays()" 
                @click.stop="updateDate(day.date)" 
                :style="{marginRight: day.friday ? '15px': '5px'}"
                :class="[sameDay(day.date,value) ? 'blue lighten-1 white--text' : '']"
                :key="day.date">{{day.initial}}</div>

            <v-menu
            transition="v-slide-y-transition"
            v-model="stepModalVisible"
            left >
            <template v-slot:activator="{ on }">
            <v-btn v-on="on" icon class="grey--text" style="margin-left:0px;"><v-icon>more_vert</v-icon></v-btn>                
            </template>
            <v-date-picker v-model="scheduleDate" no-title scrollable>

            </v-date-picker>
            </v-menu>
  </div>
</template>

<script>
    import DateHelpers from '../helpers/DateHelpers'
    import { dateFormats } from '../helpers/DateHelpers'
    import { addDays, format, isSameDay } from 'date-fns'
    
    export default {
        props: ['value'],
        data() {
            return {
                stepModalVisible: false,
                scheduleDate: this.value
            }
        },
        watch: {
            value: function(){
                this.scheduleDate = this.value
            },
            scheduleDate: function(){
                if(this.scheduleDate && this.scheduleDate != this.value)
                    this.updateDate(this.scheduleDate)
            }
        },
        methods: {
            updateDate(dt) {
                this.$emit('input', dt)
                this.$emit('change', dt)
            },
            upcomingDays: function () {
                let days = [];
                for (let n = 0; n < 8; n++) {
                    //let dt = moment().add(n, 'days')
                    let dt = addDays(new Date(), n)
                    let initial = format(dt, 'EEEE').charAt(0)
                    let day = {
                        initial: initial,
                        date: format(dt, dateFormats.BACKWARDS),
                        today: n == 0,
                        friday: initial == 'F'
                    }
                    if (initial != 'S')
                        days.push(day);
                }

                //Don't pad friday if it's the last day...
                days[days.length - 1].friday = false

                return days
            },
            sameDay: function(d1, d2) {
                const date1 = DateHelpers.backwardsToDate(d1)
                const date2 = DateHelpers.backwardsToDate(d2)
                return isSameDay(date1, date2)
            }            
        }
    }
</script>

<style>
    .day-box {
        border:solid 1px #ccc; border-radius:2px; 
        padding:5px;display:inline-block;margin-right:4px;width:35px;
        text-align:center;color:#666
    }

    .day-box:hover {
        background-color: #eee;
        cursor: pointer;
    }

</style>    


// WEBPACK FOOTER //
// Scheduler.vue?db859f82